define( [
	"./cssExpand"
], function( cssExpand ) {
	"use strict";

	return new RegExp( cssExpand.join( "|" ), "i" );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/css/var/rboxStyle.js
// module id = 826
// module chunks = 1